module.exports = __webpack_public_path__ + "img/body-2-lg.7d2f34a3.png";